var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_3532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1313 13.869C8.96127 12.699 8.07927 11.389 7.49327 10.06C7.37027 9.77897 7.44227 9.44997 7.65927 9.23297L8.47827 8.41397C9.14927 7.74297 9.14927 6.79397 8.56327 6.20797L7.39027 5.03497C6.60927 4.25397 5.34327 4.25397 4.56227 5.03497L3.91027 5.68597C3.16927 6.42697 2.86027 7.49597 3.06027 8.55597C3.55427 11.169 5.07227 14.03 7.52127 16.479C9.97027 18.928 12.8313 20.446 15.4443 20.94C16.5043 21.14 17.5733 20.831 18.3143 20.09L18.9653 19.439C19.7463 18.658 19.7463 17.392 18.9653 16.611L17.7923 15.438C17.2063 14.852 16.2563 14.852 15.6713 15.438L14.7683 16.342C14.5513 16.559 14.2223 16.632 13.9413 16.508C12.6123 15.921 11.3013 15.038 10.1313 13.869Z",
    fill: "white",
    fillOpacity: 0.6,
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 9V3H14.9999",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 9L20.9999 3L14.9999 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 9L20.9999 3",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_3532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutbound);
export default __webpack_public_path__ + "static/media/outbound.26db58812490dc60ee8e8804805a8bf6.svg";
export { ForwardRef as ReactComponent };